module.exports = __webpack_public_path__ + "img/goldmine_tech_Normal_ua.79a20763.webp";